import { Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import EditIcon from '@mui/icons-material/Edit';
import LockStatus from '../LockStatus';
import { useContext } from 'react';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';

export default ({
  disabled,
  onClick
}: {
  disabled: boolean;
  onClick: () => void;
}) => {
  const { state } = useContext(WorkflowEngineContext);

  const { lockStatus } = state;

  const editButton = (
    <Button
      variant="outlined"
      startIcon={lockStatus?.lockedDate ? <LockIcon /> : <EditIcon />}
      sx={{ color: 'black', borderColor: 'black' }}
      onClick={onClick}
      disabled={disabled || lockStatus?.isLockedByOtherUser}
    >
      Edit Workflow
    </Button>
  );

  return lockStatus?.isLockedByOtherUser ? (
    <LockStatus lockStatus={lockStatus}>
      <span>{editButton}</span>
    </LockStatus>
  ) : (
    editButton
  );
};
